module.exports = __webpack_public_path__ + "img/omar.115982bc.jpg";